import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import PricingSection from '../components/landing/PricingSection';

const PricingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      <main className="pt-24 pb-16">
        <PricingSection />

        {/* FAQ */}
        <section className="section section-alt">
          <h2 className="heading-2 text-center mb-8">Pricing FAQ</h2>
          <div className="max-w-2xl mx-auto space-y-6">
            {[
              {
                q: "When does my access start?",
                a: "Immediately. As soon as your payment is confirmed you can start practising straight away."
              },
              {
                q: "What's included in all plans?",
                a: "Every plan includes full access to all 11 modules, unlimited practice, AI feedback, assessments, TPI certification, dictionary, and offline mode. The only difference is the duration."
              },
              {
                q: "What does the price include?",
                a: "The listed prices are base prices. GST at 18% is added at checkout. For example, 3 months at ₹1,500 + ₹270 GST = ₹1,770 total."
              },
              {
                q: "Can I extend my plan later?",
                a: "Yes, you can purchase additional time at any point. Your remaining access will be added to the new duration."
              },
              {
                q: "What payment methods do you accept?",
                a: "We accept all major credit cards, debit cards, UPI, and net banking."
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 border border-black/5">
                <h3 className="font-medium text-[#1a1a2e] mb-2">{faq.q}</h3>
                <p className="text-sm text-[#83928c]">{faq.a}</p>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PricingPage;
